import React from 'react';
import { useConnect } from '@lore/query-connect';
import useStewardshipFilter from '../../partners/useStewardshipFilter';
import REQUIRED_FIELDS from '../../offers/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';
import { tags_partner } from '../../../utils/query-helpers';

export default function SharedOffer(props) {
  const { network, schoolStart, schoolEnd, titleOnly } = props;

  const stewardshipFilter = useStewardshipFilter();

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfOffers',
            relation: 'offers',
            $where: {
              // published: true,
              activityId: {
                $null: false
              },
              networkId: network?.id,
              createdAt: {
                $lte: schoolStart,
                $gte: titleOnly ? undefined : previousSchoolStart
              },
              $and: REQUIRED_FIELDS.$and
            }
          }
        ],
        $where: {
          ...tags_partner(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfOffers: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  const newUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfOffers',
            relation: 'offers',
            $where: {
              // published: true,
              activityId: {
                $null: false
              },
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              },
              $and: REQUIRED_FIELDS.$and
            }
          }
        ],
        $where: {
          ...tags_partner(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfOffers: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousUsers.state === PayloadStates.FETCHING ||
    newUsers.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Shared an Offer"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Shared an Offer"
      value={newUsers.meta.totalCount}
      previousValue={previousUsers.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
